<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">
        @if (step == 1) {
            <div>Choix de votre nouveau forfait @if (steps) {
                <span>({{ step }}/{{ steps }})</span>
            }</div>
        }
        @if (step == 2) {
            <div>Conditions de votre nouveau forfait ({{ step }}/{{ steps }})</div>
        }
        @if (step == 3) {
            <div>{{ thirdStep }} ({{ step }}/{{ steps }})</div>
        }
        @if (step == 4 && selectedOffer != null && line.oberthur == false) {
            <div>Changement gratuit de carte SIM ({{ step }}/{{ steps }})</div>
        }
    </div>
</div>
@if (line && step == 1) {
    <div>
        <div class="col-12">
            <div class="bold-text pb-3">Ligne : <span class="bold-black-text">{{ line.phoneNumber }}</span></div>
            <div class="bold-text pb-3">Forfait actuel : <span class="bold-blue-text">{{ offerName }}</span></div>
            @if (offerDetails && changeOffersEligibleList.length > 0 && line.phoneNumber.length === 10) {
                <div class="bold-text pb-3"> Je choisis le forfait :
                    <select name="offer" class="custom-select w-50" (change)="setSelectedOffer($event)">
                        @for (offer of changeOffersEligibleList; track offer) {
                            <option value="{{ offer.offer_id }}"
                                    [selected]="selectedOffer && selectedOffer.offer_id == offer.offer_id">{{ offer.label }}
                            </option>
                        }
                    </select>
                    <br><br>
                    @if (offerDetails) {
                        <app-shunters [shunters]="getShunters(offerDetails)"></app-shunters>
                    }
                </div>
            }
        </div>
        @if (changeOffersEligibleList.length == 0) {
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100">Vous bénéficiez déjà du meilleur forfait disponible actuellement</div>
            </div>
        }
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                @if (changeOffersEligibleList.length > 0 && line.phoneNumber.length === 10) {
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(1)">Suivant<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}
@if (step == 2 && selectedOffer != null) {
    <div>
        <div class="col-12">
            <div class="bold-text pb-3">Nouveau forfait : <span class="bold-blue-text">{{ selectedOffer.label }}</span>
            </div>
            <div [innerHTML]="getPriceText()"></div>
            Pour en savoir plus, consultez <a target="_blank" href="{{ selectedOffer.guide_url }}">le Guide Tarifaire de
            l'offre {{ selectedOffer.label }}</a>.
            <br><br>
            @if (line.network.toLowerCase() == 'orange') {
                <div>
                    Ce forfait est uniquement disponible sur le réseau SFR. Une nouvelle carte SIM compatible SFR vous
                    sera envoyée gratuitement.
                </div>
            }
            @if (line.network.toLowerCase() == 'sfr' && offerPromoDetails && offerPromoDetails.is_last_month) {
                <div>
                    Attention : votre promotion se termine ce mois-ci. Si vous changez de forfait le mois prochain, vous
                    ne bénéficierez pas des tarifs réduits.
                </div>
            }
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(-1)">Retour<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="setStep(1)">Suivant<span></span></button>
            </div>
        </div>
    </div>
}
@if (step == 3 && selectedOffer != null && line.network.toLowerCase() == 'sfr') {
    <div>
        <div class="col-12">
            <div class="bold-text pb-3">Ligne : <span class="bold-black-text">{{ line.phoneNumber }}</span></div>
            <div class="bold-text pb-3">Nouveau forfait : <span class="bold-blue-text">{{ selectedOffer.label }}</span>
            </div>
            @if (environment.data.brand == 'prixtel') {
                <div class="bold-text">Quand votre nouveau forfait doit-il prendre effet ?</div>
            }
            @if (environment.data.brand == 'coriolis') {
                <div class="bold-text">
                    Votre nouveau forfait prendra effet le <span class="bold-blue-text">{{ getBillCycleDate() }}</span>
                </div>
            }
            @if (environment.data.brand == 'prixtel') {
                <div class="pl-4">
                    <input type="radio" id="date1" class="form-check-input" name="date" value="next_month" checked
                           (click)="changeType('next_month')" [(ngModel)]="type"/>
                    <label class="form-check-label" for="date1">
                        Au début du mois prochain : <span class="bold-blue-text">Gratuit</span>
                    </label>
                </div>
            }
            @if (priceDetails && environment.data.brand == 'prixtel') {
                <div class="pl-4">
                    <input type="radio" id="date2" class="form-check-input" name="date" value="immediate"
                           (click)="changeType('immediate')" [(ngModel)]="type"/>
                    <label class="form-check-label" for="date2">
                        Immédiatement : <span
                            class="bold-blue-text">{{ priceDetails?.price }}</span>@if (priceDetails?.perMonth) {
                        <span>/mois</span>
                    }
                    </label>
                </div>
            }
            @if (line.network.toLowerCase() == 'sfr' && offerPromoDetails && offerPromoDetails.is_last_month) {
                <div class="pt-2">
                    Attention : votre promotion se termine ce mois-ci. Si vous changez de forfait le mois prochain, vous
                    ne bénéficierez pas des tarifs réduits.
                </div>
            }
            <div>
                <br>
                <strong>En validant le changement de forfait, vous acceptez les conditions du <a target="_blank"
                                                                                                 href="{{ selectedOffer.guide_url }}">Guide
                    Tarifaire de l'offre {{ selectedOffer.label }}</a></strong>.
            </div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column column" (click)="setStep(-1)">Retour<span></span>
                </button>
                <button type="button" class="cta_btn level_2 column"
                        (click)="setStep(1)">{{ !line.oberthur ? 'Suivant' : 'Valider' }}<span></span></button>
            </div>
        </div>
    </div>
}
@if (step == 3 && selectedOffer != null && line.network.toLowerCase() == 'orange') {
    <div>
        <div class="col-12">
            <div class="bold-text pb-3">Nouveau forfait : <span class="bold-blue-text">{{ selectedOffer.label }}</span>
            </div>
            Ce forfait utilise le réseau SFR, une nouvelle carte SIM SFR va donc vous être envoyée gratuitement. Elle
            s'activera à la date que vous aurez choisie ci-dessous.
            <br><br>
            <div class="bold-text">Date du changement de réseau* :
                <mat-form-field>
                    <input matInput (dateChange)="setSelectedDate($event.value)" [formControl]="startDate"
                           [matDatepicker]="picker" [matDatepickerFilter]="portabilityDateFilter">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon id="calendar-icon">calendar_today</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            @if (this.displayError) {
                <div class="form-text error-message pb-2">Merci de choisir une date valide en cliquant sur le
                    calendrier.
                </div>
            }
            Votre nouveau forfait apparaîtra dans votre Espace client à cette date mais ses tarifs s’appliqueront sur
            tout le mois {{ getMonth() }} et jusqu'en {{ getEndDate() }} inclus.
            <br><br><br>
            @if (shippingAddress) {
                <div>
                    Votre carte SIM sera livrée à l'adresse suivante :
                    <br><br>
                    <div class="d-flex justify-content-center">
                        <app-address-card [shippingAddress]="shippingAddress"
                                          [displayButton]="false"></app-address-card>
                    </div>
                </div>
            }
        </div>
        Pour modifier ou compléter votre adresse, <a routerLink="/compte/adresses/modifier/adresse-livraison">cliquez
        ici.</a> Une fois que vous l'aurez mise à jour, vous pourrez relancer la procédure de changement de forfait.
        <br>
        Si cette adresse est exacte, cliquez sur "Valider" pour confirmer votre demande de changement de forfait.
        <br><br>
        <strong>En validant le changement de forfait, vous acceptez les conditions du <a target="_blank"
                                                                                         href="{{ selectedOffer.guide_url }}">Guide
            Tarifaire de l'offre {{ selectedOffer.label }}</a> et le passage sur le réseau SFR.</strong> Il ne sera
        alors plus possible d’annuler ni de décaler le changement de réseau. Si vous souhaitez transférer votre ligne
        chez un autre opérateur, il
        faudra attendre que votre ligne soit activée sur le réseau SFR.
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column column" (click)="setStep(-1)">Retour<span></span>
                </button>
                @if (shippingAddress) {
                    <button type="button" class="cta_btn level_2 column" (click)="orangeConfirmation()">
                        Valider<span></span></button>
                }
            </div>
        </div>
    </div>
}
@if (step == 4 && selectedOffer != null && line.oberthur == false) {
    <div>
        <div class="col-12">
            @if (line.oberthur == false) {
                <div>
                    Pour vous permettre de profiter de ce forfait, une nouvelle carte SIM 4G/5G va vous être envoyée
                    gratuitement à l'adresse ci-dessous.
                    <br><br>
                </div>
            }
            <div class="d-flex justify-content-center">
                @if (shippingAddress) {
                    <app-address-card [shippingAddress]="shippingAddress" [displayButton]="false"></app-address-card>
                }
            </div>
        </div>
        Pour modifier ou compléter votre adresse, <a routerLink="/compte/adresses/modifier/adresse-livraison">cliquez
        ici.</a> Une fois que vous l'aurez mise à jour, vous pourrez relancer la procédure de changement de forfait.
        <br>
        Si cette adresse est exacte, cliquez sur "Valider" pour confirmer votre demande de changement de forfait.
        <br><br>
        <strong>En validant le changement de forfait, vous acceptez les conditions du <a target="_blank"
                                                                                         href="{{ selectedOffer.guide_url }}">Guide
            Tarifaire de l'offre {{ selectedOffer.label }}</a></strong>.
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column column" (click)="setStep(-1)">Retour<span></span>
                </button>
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                </button>
            </div>
        </div>
    </div>
}
